import * as stagesCase from "../../Stages/StagesCase";
import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";
import { ContractUnion } from "../../../types/ContractUnion";

export const contractRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (contractCase: ContractUnion) => {
    let requiredFields = abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](contractCase);
    requiredFields.push("objectiveLawFirm");
    return requiredFields;
  },
};
